import {EnumDefinition, EnumMap} from './enum_types';

export function getEnumMessageKeyFromEnumDefinition(enumDefinition: EnumDefinition | undefined): string | undefined {
  return enumDefinition?.messageKey;
}

export function getEnumMessageKeyFromEnumValues(enumValueName: string, enumValues: EnumDefinition[] | undefined): string | undefined {
  return getEnumMessageKeyFromEnumDefinition(enumValues?.find((item) => item.name === enumValueName));
}

export function getEnumMessageKeyFromEnumMap(enumMap: EnumMap, enumName: string, enumValueName: string): string | undefined {
  return getEnumMessageKeyFromEnumValues(enumValueName, enumMap?.[enumName]);
}
